import React from 'react';
import { Outlet } from 'react-router-dom';

const layoutStyles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--color-bg-primary)',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
};

export default function PublicLayout() {
  return (
    <div style={layoutStyles.container}>
      <main style={layoutStyles.main}>
        <Outlet />
      </main>
    </div>
  );
}
